import toast from 'react-hot-toast';

const errorHandler = (error: any) => {
  let errorMessage: string | null = null;

  if (error?.response) {
    const { status, data } = error.response;

    switch (status) {
      case 400:
        errorMessage = extractErrorMessage(data) || 'Bad Request.';
        console.error('Bad Request:', data);
        break;
      case 401:
        errorMessage = 'Unauthorized: Please log in again.';
        console.warn('Unauthorized');
        break;
      case 403:
        errorMessage = 'Forbidden: You do not have permission.';
        console.warn('Forbidden');
        break;
      case 404:
        errorMessage = 'Not Found: The resource does not exist.';
        console.warn('Not Found');
        break;
      case 500:
        errorMessage = 'Server Error: Please try again later.';
        console.error('Server Error:', data);
        break;
      default:
        errorMessage =
          extractErrorMessage(data) || `Error ${status}: Something went wrong.`;
        console.error('Unhandled Error:', data);
    }
  } else if (error?.request) {
    errorMessage =
      'No response from server. Please check your internet connection.';
    console.error('No response from server:', error.request);
  }

  if (errorMessage) toast.error(errorMessage);
  return errorMessage;
};

// Helper function to extract nested error messages
const extractErrorMessage = (data: any): string | null => {
  return (
    data?.message ||
    data?.error?.description ||
    data?.error?.message ||
    data?.error?.name ||
    data?.value?.error?.message ||
    null
  );
};

export default errorHandler;
